import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PostCard } from "@/pages/Blog";

export const MembersBlog = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);
  return (
    <div data-testid="members-blog">
      <span className="eyebrow">The Ambassadors Blog</span>
      <h1 className="font-serif-h font-light text-4xl sm:text-5xl text-[#577731] mt-4 mb-10">Teachings for the path</h1>
      <div className="space-y-8">{posts.map((p) => <PostCard key={p.id} post={p} />)}</div>
    </div>
  );
};
